import { render, staticRenderFns } from "./AccountHolderDetails.vue?vue&type=template&id=1a4e8d34&scoped=true"
import script from "./AccountHolderDetails.vue?vue&type=script&lang=ts"
export * from "./AccountHolderDetails.vue?vue&type=script&lang=ts"
import style0 from "./AccountHolderDetails.vue?vue&type=style&index=0&id=1a4e8d34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4e8d34",
  null
  
)

export default component.exports